import { render, staticRenderFns } from "./LocalGroupIndex.vue?vue&type=template&id=7f22a7e0&scoped=true"
import script from "./LocalGroupIndex.vue?vue&type=script&lang=js"
export * from "./LocalGroupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22a7e0",
  null
  
)

export default component.exports